import React from 'react'
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'

import { FONT_FAMILY_SECONDARY } from '../theme'
import { MEDIA_QUERY_DESKTOP } from '../utils/media-query'
import Container from './Container'

const Component = styled.div`
  padding: 1rem 0 0 0;

  ${MEDIA_QUERY_DESKTOP} {
    padding: 4rem 0 2rem 0;
  }
`

const Title = styled.h1`
  font-family: ${FONT_FAMILY_SECONDARY};
  color: white;
  font-weight: 700;

  ${MEDIA_QUERY_DESKTOP} {
    font-size: ${props => props.$fontSize}px;
    letter-spacing: -1.5px;
    line-height: 1.2;
  }
`

const Content = styled.div`
`

const PrimaryContent = styled.div`
  display: flex;
  align-items: center;
`

const TextContent = styled.div``

const Description = styled.div`
  margin-top: 1rem;
  color: rgba(255, 255, 255, .5);

  ${MEDIA_QUERY_DESKTOP} {
    font-size: 20px;
  }
`

const Footer = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;

  ${MEDIA_QUERY_DESKTOP} {
    margin-bottom: 0;
  }
`

const ImageContainer = styled.div`
  position: relative;
  margin-left: auto;
  display: none;

  ${MEDIA_QUERY_DESKTOP} {
    display: block;
  }
`

const Hero = ({
  title,
  titleFontSize = 72,
  description,
  footer,
  image
}) => {
  return (
    <Component>
      <Container>
        <Content>
          <PrimaryContent>
            <TextContent>
              <Title $fontSize={titleFontSize}>
                {title}
              </Title>
              <Description>
                {description}
              </Description>
              {footer && (
                <Footer>
                  {footer}
                </Footer>
              )}
            </TextContent>
            {(!isMobile && image) && (
              <ImageContainer>
                {image}
              </ImageContainer>
            )}
          </PrimaryContent>
        </Content>
      </Container>
    </Component>
  )
}

export default Hero
